import React, { useState, useEffect } from 'react'
import IconButton from '@material-ui/core/IconButton'
import Tooltip from '@material-ui/core/Tooltip'
import DeleteIcon from '@material-ui/icons/Delete'
import { connect } from 'react-redux'
import { CircularProgress } from '@material-ui/core'
import { reduxForm } from 'redux-form'
import { deletePedidosDeBruto } from '../actions/TablaPedidoCamionesEnCaladoActions'
import { FORM_PEDIDO_EGRESO_CALADO } from '../../../config/forms'

function OperacionesPedidosCalado (props) {
  const { fecha, deletePedidosDeBruto } = props
  const [loading, setLoading] = useState(false)

  const startTime = () => 5
  const [seconds, setSeconds] = useState(startTime)

  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1)
      }
      if (seconds === 0) {
        clearInterval(interval)
        setLoading(false)
      }
    }, 1000)

    return () => {
      clearInterval(interval)
    }
  })

  function deletePedido () {
    setLoading(true)
    setSeconds(startTime)
    deletePedidosDeBruto(fecha, props.roles)
  }

  return (
    <div style={{ display: 'flex' }}>
      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        {loading
          ? <div style={{ marginLeft: '10px', width: '10%' }}>
            <CircularProgress size={'1rem'} style={{ color: '#3f51b5' }} />
          </div>
          : <Tooltip title={'Eliminar pedido'}>
            <IconButton onClick={deletePedido}>
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        }
      </div>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    roles: state.auth.roles
  }
}

const mapActionsToProps = {
  deletePedidosDeBruto
}

const withRedux = connect(mapStateToProps, mapActionsToProps)

const withReduxForm = reduxForm({
  form: FORM_PEDIDO_EGRESO_CALADO,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
  destroyOnUnmount: false,
  updateUnregisteredFields: true
})
export default withRedux(withReduxForm(OperacionesPedidosCalado))
